<template>
  <div class="container" id="container">
    <div id="dashboard" >
      <!-- Dashboard header -->
      <div class="dashboard__header mb-4 row no-gutters">

        <!-- Dashboard Title -->
        <div class="col-sm-12 col-md-4 pt-md-1 pt-sm-0 dashboard__header--col" ref="topTitle">
          <div>
            <svg class="dashboard__header--icon h-100 display-inline-block" width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8393 0.5625C6.19596 0.5625 0 6.8584 0 14.625C0 17.2031 0.684756 19.6182 1.87695 21.6953C2.14653 22.165 2.66022 22.4375 3.19553 22.4375H24.483C25.0184 22.4375 25.532 22.165 25.8016 21.6953C26.9938 19.6182 27.6786 17.2031 27.6786 14.625C27.6786 6.8584 21.4826 0.5625 13.8393 0.5625ZM21.6815 9.07861L16.4654 16.1455C16.7446 16.6157 16.9147 17.1606 16.9147 17.75C16.9147 18.3223 16.7523 18.8511 16.488 19.3125H11.1906C10.9263 18.8511 10.7639 18.3223 10.7639 17.75C10.7639 16.0239 12.1406 14.625 13.8393 14.625C14.1108 14.625 14.3688 14.6719 14.6197 14.7393L19.8363 7.67139C20.2198 7.15576 20.9415 7.05029 21.4514 7.43701C21.9603 7.82568 22.064 8.56055 21.6815 9.07861Z" fill="#2B4D75"/></svg>
            <h1 class="dashboard__header--title m-0 header">Tasks</h1>
            <!-- <button class="btn btn--white" @click="getTemplate()">Generate</button> -->
          </div>
        </div>

        <!-- Date Range -->
        <div class="col-sm-12 col-md-8 text-right dashboard__header--col-right">
          <div class="dashboard__header--picker display-table-cell mt-sm-2 mt-md-2 mt-lg-0 display-inline-block">
            <date-range-picker @toggle="detectDateRangeState" v-clickaway="closeDateRangePicker" @update="updateDatee" ref="picker" opens="left" :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY', applyLabel: 'Apply', cancelLabel: 'Cancel' }" :showWeekNumbers="false" :timePicker="false" :autoApply="false" v-model="showDateRange" placeholder="mm/dd/yyyy">
              <div slot="input" slot-scope="picker">
                  <button class="btn btn--white display-table px-3" ref="btn-picker">
                      <svg class="display-table-cell mr-2" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 15.4062C0 16.2861 0.713867 17 1.59375 17H13.2812C14.1611 17 14.875 16.2861 14.875 15.4062V6.375H0V15.4062ZM2.125 9.03125C2.125 8.73906 2.36406 8.5 2.65625 8.5H12.2188C12.5109 8.5 12.75 8.73906 12.75 9.03125V11.1562C12.75 11.4484 12.5109 11.6875 12.2188 11.6875H2.65625C2.36406 11.6875 2.125 11.4484 2.125 11.1562V9.03125ZM13.2812 2.125H11.6875V0.53125C11.6875 0.239062 11.4484 0 11.1562 0H10.0938C9.80156 0 9.5625 0.239062 9.5625 0.53125V2.125H5.3125V0.53125C5.3125 0.239062 5.07344 0 4.78125 0H3.71875C3.42656 0 3.1875 0.239062 3.1875 0.53125V2.125H1.59375C0.713867 2.125 0 2.83887 0 3.71875V5.3125H14.875V3.71875C14.875 2.83887 14.1611 2.125 13.2812 2.125Z" fill="#52749C"/>
                      </svg>
                      <!-- <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['This year'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['This year'][1]) == dateFormat(picker.endDate)">This Year: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['This month'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['This month'][1]) == dateFormat(picker.endDate)">This Month: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['Last week'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['Last week'][1]) == dateFormat(picker.endDate)">Last Week: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['Last month'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['Last month'][1]) == dateFormat(picker.endDate)">Last Month: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges.Today[0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges.Today[1]) == dateFormat(picker.endDate)">Today: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges.Yesterday[0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges.Yesterday[1] == picker.endDate)">Yesterday: </span> -->
                      <span class="display-table-cell" v-if="picker.startDate == null && picker.endDate == null">Select date range</span>
                      <span class="display-table-cell mx-2" v-else>{{dateFormat(picker.startDate)}} - {{dateFormat(picker.endDate)}}</span>
                      <svg class="display-table-cell" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.594098 0.908325L8.22252 0.908325C8.75074 0.908325 9.01526 1.54697 8.64176 1.92047L4.82755 5.73468C4.59602 5.96621 4.2206 5.96621 3.98907 5.73468L0.174856 1.92047C-0.198674 1.54697 0.0658798 0.908325 0.594098 0.908325Z" fill="#52749C"/>
                      </svg>
                  </button>
              </div>
            </date-range-picker>
          </div>
        </div>

      </div>

      <!-- Tasks Charts -->
      <div class="dashboard__header mb-4 row no-gutters" style="margin: 0 -7.5px">

        <!--  All Task with Status Done  -->
        <div class="col-md-6 dashboard__header--col" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="tasks" subType="Done" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate" ></mini-chart>
        </div>


        <!--  All Task with Status Failed -->
        <div class="col-md-6 dashboard__header--col" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="tasks" subType="Failed" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div>

        <!--  Task Prospecting  -->
        <!-- <div class="col-md-3 dashboard__header--col mt-3" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="task_type" subType="Prospecting" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate" ></mini-chart>
        </div> -->


        <!--  Task Custom Conversion -->
        <!-- <div class="col-md-3 dashboard__header--col mt-3" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="task_type" subType="Custom Conversion" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div> -->

         <!--  Task Audience  -->
        <!-- <div class="col-md-3 dashboard__header--col mt-3" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="task_type" subType="Audience" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate" ></mini-chart>
        </div> -->


        <!--  Task dpa -->
        <!-- <div class="col-md-3 dashboard__header--col mt-3" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="task_type" subType="dpa" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div> -->

         <!--  Task Scaling  -->
        <!-- <div class="col-md-4 dashboard__header--col mt-3" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="task_type" subType="Scaling" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate" ></mini-chart>
        </div> -->


        <!--  Task Manual Retargeting -->
        <!-- <div class="col-md-4 dashboard__header--col mt-3" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="task_type" subType="Manual Retargeting" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div> -->

        <!--  Task Retention -->
        <!-- <div class="col-md-4 dashboard__header--col mt-3" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="task_type" subType="Retention" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div> -->

      </div>

      <!-- Table -->
      <div id="products-table">
        <!-- v-if="(tasksList && tasksList.length && !loading) || showSearch" -->
        <div class="products-table__search" >
            <s-input placeholder="Search for tasks by domain or email" v-model="searchTasks"></s-input>
        </div>
        <s-card class="products-table__card border-top-0 p-0">
          <s-card-body class="product-table__table p-0">
              <div class="product-table__table-container" @scroll="getScrollPos">
                  <div class="div-shadow-left" v-if="!hideShadows && scrollIn && scrollIn !== 'left' && tasksList && tasksList.length"></div>
                  <!-- tasksList && tasksList.length &&  -->
                  <!-- style="width: 1320px !important;" -->
                  <table v-if="(!loading) || showSearch" class="product-table__table--table"  id="myTable">
                      <thead class="product-table__table--header border-0 p-0 mb-4">
                          <!-- ID -->
                          <td class="text-truncate product-table__table--header-joined">
                              <span>ID</span>
                          </td>
                          <!-- Name -->
                          <td class="text-truncate product-table__table--header-domain">
                              <span>Name</span>
                          </td>
                          <!-- Created -->
                          <td class="text-truncate product-table__table--header-joined">
                              <span>Created</span>
                          </td>
                          <!-- STATUS -->
                          <td class="text-truncate product-table__table--header-charge-status">
                              <span>STATUS</span>
                          </td>
                          <!-- Account -->
                          <td class="text-truncate product-table__table--header-trail-started">
                              <span>Account</span>
                          </td>
                          <!-- Details -->
                          <td class="text-truncate product-table__table--header-trail-started">
                              <span>Details</span>
                          </td>
                      </thead>
                      <tbody class="product-table__table--body">
                          <tr class="w-100 display-table-cell" v-if="loading && showSearch">
                              <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                          </tr>
                          <tr class="w-100 display-table-cell" v-if="!loading && (tasksList == null || tasksList.length == 0)">
                              <p class="my-3 position-relative font-weight-sbold" style="left:40%;">No Results</p>
                          </tr>
                          <div v-if="tasksList && tasksList.length > 0">
                            <tr  v-show="!loading" v-for="(task, taskIndex) in tasksList" :key="taskIndex" class="product-table__table--row">
                                <!-- ID -->
                                <td class="product-table__table--body-joined">
                                  <p class="text-truncate">{{task.id}}</p>
                                </td>
                                <!-- Name -->
                                <td :tooltip-position="taskIndex==0?'right':'top'" :tooltip="task.name" class="product-table__table--body-domain">
                                  <p class="text-truncate">{{task.name}}</p>
                                </td>
                                <!-- CREATED -->
                                <td class="product-table__table--body-joined">
                                    <p class="text-truncate">{{task.created_at?fromNow(task.created_at):''}}</p>
                                </td>
                                <!-- STATUS -->
                                <td class="product-table__table--body-charge-status">
                                    <img class="display-table-cell" v-if="task.status=='Done'" src="../../assets/images/status/success.svg" alt="">
                                    <img class="display-table-cell" v-else-if="task.status=='Failed' || task.status=='Deleted'" src="../../assets/images/status/danger.svg" alt="">
                                    <img class="display-table-cell" v-else-if="task.status=='Stopped' || task.status=='Pending'" src="../../assets/images/status/warning.svg" alt="">
                                    <img class="display-table-cell" v-else src="../../assets/images/status/secondary.svg" alt="">
                                    <span class="pl-2 display-table-cell text-truncate" >{{task.status}}</span>
                                    <span class="pl-2 display-table-cell font-weight-sbold" >({{task.value.toFixed(0)}}%)</span>
                                </td>
                                <!-- Account -->
                                <td class="product-table__table--body-trail-started">
                                    <a :href="`/account/${task.account_id}`" class="text-truncate text-primary cursor-pointer" style="width: max-content;">Go to account</a>
                                </td>
                                <!-- Details -->
                                <td class="product-table__table--body-trail-started">
                                  <a :href="`/tasks/task/${task.id}`" class="btn btn--primary">
                                    <span class="display-table-cell">Details</span>
                                  </a>
                                </td>
                            </tr>
                          </div>
                      </tbody>
                  </table>
                  <div class="div-shadow-right" v-if="!hideShadows && scrollIn && scrollIn !== 'right' && ((tasksList && tasksList.length)||showSearch)"></div>
              </div>
          </s-card-body>
          <s-card-body v-if="tasksList && tasksList.length && !showSearch && linkLoadMoreTasks && !loading" class="p-0 product-table__load-more text-center">
              <button v-if="!loadingLoadMore" class="btn btn--white" @click="loadMoreTasks()">Load More</button>
              <s-loader :type="'scalify'" v-else></s-loader>
          </s-card-body>
        </s-card>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment';
import MiniChart from './MiniChart.vue';
import DateRangePicker from 'vue2-daterange-picker';
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


export default {
  name: 'taskTable',

  components:{
    MiniChart,
    DateRangePicker
  },

  props: {},

  computed:{
  },

  data(){
    return{
      showDateRange: {},
      valueUpdateDate: null,
      showRangePicker:false,
      tasksList: [],
      searchTasks: "",
      showSearch: false,
      showColumns: false,
      loading:false,
      hideShadows:false,
      scrollIn:"left",
      linkLoadMoreTasks: false,
      loadingLoadMore: false,
      currentPage: 1,
      isLoadingSearch: false
    }
  },

  methods:{
    closeDateRangePicker(){
      this.$nextTick(()=>{
        if(this.showRangePicker){
          this.$refs["btn-picker"].click()
        }
      })
    },
    detectDateRangeState(show){
      this.showRangePicker = show
    },
    async updateDatee(value){
      this.valueUpdateDate = value;
      this.loading = true;
      let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
      let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
      this.currentPage = 1;
      const tasks = await this.tasksTable(start,end,this.currentPage);
      if (tasks && tasks.data) {
        this.tasksList = tasks.data;
        if (tasks.data.length > 0) {

          tasks.data.map((task)=>{
            task.value = 0;
            if (task && task.actions && task.actions.length > 0) {
              let actoinValue = 100 / task.actions.length;
              let taskValue = 0;
              task.actions.map((action)=>{
                if (action.status == 1) {
                  taskValue = taskValue + actoinValue;
                }
              })
              task.value = taskValue;
            }
          })
        }
        if (tasks && tasks.data && tasks.data.length >= 25) {
          this.linkLoadMoreTasks = true;
        }else{
          this.linkLoadMoreTasks = false;
        }
        this.isLoadingSearch = false;
      }
      this.loading = false;
    },
    dateFormat(date){
      const m = moment(date);
      const ord = m.format("ll");
      return ord;
    },
    getScrollPos ({ target: { scrollLeft ,clientWidth, scrollWidth }}) {
      var scroll = "left"
      if(scrollLeft == 0){
          scroll = "left"
      }
      else if(scrollLeft+clientWidth < scrollWidth){
          scroll = "middle"
      }
      if(scrollLeft+clientWidth >= scrollWidth){
          scroll = "right"
      }
      this.scrollIn = scroll
    },
    updateTableWidth(){
      this.$nextTick(()=>{
        var x = document.getElementById("myTable")
        if(x){
            var items = x.children[0].children
            var w = 0
            for(var i=0;i<items.length;i++){
                w = w + items[i].clientWidth
            }
            if(parseInt(w) < 1110){
                this.hideShadows = true
            }
            else{
                this.hideShadows = false
            }
            x.style.width=w+'px'
            this.$forceUpdate()
        }
      })
    },
    async loadMoreTasks(){
      try {
        this.loadingLoadMore = true;
        let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
        let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
        this.currentPage = parseInt(this.currentPage) + 1;
        let detailsTasks;
        if (this.isLoadingSearch) {
          detailsTasks = await this.taskSearch(this.searchTasks,this.currentPage);
        }else{
          detailsTasks = await this.tasksTable(start,end,this.currentPage);

        }
        if (detailsTasks && detailsTasks.data) {
          this.currentPage = detailsTasks.current_page;
          if (detailsTasks.data.length > 0) {

            detailsTasks.data.map((task)=>{
              task.value = 0;
              if (task && task.actions && task.actions.length > 0) {
                let actoinValue = 100 / task.actions.length;
                let taskValue = 0;
                task.actions.map((action)=>{
                  if (action.status == 1) {
                    taskValue = taskValue + actoinValue;
                  }
                })
                task.value = taskValue;
              }
            })
          }
          this.tasksList = this.tasksList.concat(detailsTasks.data);
          if (detailsTasks && detailsTasks.data && detailsTasks.data.length >= 25) {
            this.linkLoadMoreTasks = true;
          }else{
            this.linkLoadMoreTasks = false;
          }
        }else{
          this.linkLoadMoreTasks = false;
        }
        this.loadingLoadMore = false;
      } catch (error) {
        this.loadingLoadMore = false;
      }
    },
    accountDetails(id){
      this.$router.push(`/tasks/account/${id}`);
    },
    taskDetails(id){
      this.$router.push(`tasks/task/${id}`);
    }
  },

  async created(){
    this.showDateRange = {};
    this.showDateRange['endDate'] = new Date();
    var makeDate = new Date();
    this.showDateRange['startDate'] = new Date(new Date().setMonth(makeDate.getMonth()-1));
  },

  watch:{

    async searchTasks(){


      if (this.searchTasks == "") {
        this.loading = true;
        this.showSearch = true
        let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
        let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
        this.currentPage = 1;
        const tasks = await this.tasksTable(start,end, this.currentPage);
        if (tasks && tasks.data) {

          if (tasks.data.length > 0) {

            tasks.data.map((task)=>{
              task.value = 0;
              if (task && task.actions && task.actions.length > 0) {
                let actoinValue = 100 / task.actions.length;
                let taskValue = 0;
                task.actions.map((action)=>{
                  if (action.status == 1) {
                    taskValue = taskValue + actoinValue;
                  }
                })
                task.value = taskValue;
              }
            })
          }
          this.tasksList = tasks.data;

          if (tasks && tasks.data && tasks.data.length >= 25) {
            this.linkLoadMoreTasks = true;
          }else{
            this.linkLoadMoreTasks = false;
          }

        }
        this.loading = false;
        this.showSearch = false

      }else if(this.searchTasks.length >= 3){
        this.loading = true;
        this.showSearch = true
        var t = 1000;
        this.currentPage = 1;
        clearTimeout(window.popTimeout);


        window.popTimeout = setTimeout(async () => {
          const resultSearch = await this.taskSearch(this.searchTasks, this.currentPage);

          if (resultSearch && resultSearch.data) {

            if (resultSearch.data.length > 0) {

              resultSearch.data.map((task)=>{
                task.value = 0;
                if (task && task.actions && task.actions.length > 0) {
                  let actoinValue = 100 / task.actions.length;
                  let taskValue = 0;
                  task.actions.map((action)=>{
                    if (action.status == 1) {
                      taskValue = taskValue + actoinValue;
                    }
                  })
                  task.value = taskValue;
                }
              })
            }

            this.tasksList = resultSearch.data;

            if (resultSearch && resultSearch.data && resultSearch.data.length >= 25) {
              this.linkLoadMoreTasks = true;
            }else{
              this.linkLoadMoreTasks = false;
            }

          }
          this.isLoadingSearch = true;

          this.showSearch = false
          this.loading = false;
        }, t);
      }

    }

  },

  async mounted(){
    this.loading = true
    let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
    let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
    const tasks = await this.tasksTable(start,end,this.currentPage);
    if (tasks && tasks.data) {

      if (tasks.data.length > 0) {

        tasks.data.map((task)=>{
          task.value = 0;
          if (task && task.actions && task.actions.length > 0) {
            let actoinValue = 100 / task.actions.length;
            let taskValue = 0;
            task.actions.map((action)=>{
              if (action.status == 1) {
                taskValue = taskValue + actoinValue;
              }
            })
            task.value = taskValue;
          }
        })
      }
      this.tasksList = tasks.data;

      if (tasks && tasks.data && tasks.data.length >= 25) {
        this.linkLoadMoreTasks = true;
      }else{
        this.linkLoadMoreTasks = false;
      }
    }
    this.loading = false
  }


}
</script>

<style scoped>

</style>
